import Content from './Content';

const OtpFail = () => {
  return <Content messages={'Mã kích hoạt / OTP hết hiệu lực'} />;
};

export default OtpFail;
